import { PhotoMeta } from '@services/image-upload/image-upload.service';

export interface PhotoUploadSource {
  path?: string;
  blob?: File;
}

/**
 * The single definition of "there is something here we can actually upload".
 *
 * `UploadQueueService.enqueue` throws when a PhotoMeta has neither a native
 * path nor a File, and the create effects have to answer the same question
 * *before* they POST the row -- otherwise a malformed photo leaves a
 * permanent server row with imageExists: false and no image will ever arrive,
 * which is precisely the grey-placeholder symptom the native queue exists to
 * eliminate. Both callers go through here so the rule cannot drift.
 *
 * Returns null when the photo is unusable.
 */
export function photoUploadSource(photo: PhotoMeta): PhotoUploadSource {
  if (!photo) {
    return null;
  }

  const path = photo.photoData ? photo.photoData.path : undefined;
  const blob = photo.file;

  if (!path && !blob) {
    return null;
  }

  return { path, blob };
}

export function hasPhotoUploadSource(photo: PhotoMeta): boolean {
  return photoUploadSource(photo) !== null;
}
